/**
 * Created by hernanherreros on 2019-08-31
 */

import * as React from 'react'
import styled from 'styled-components'
import { Icon } from 'antd'
import { Link } from 'react-router-dom'

interface Props {
  title: string;
  uuid: string;
  completed?: boolean;
  onClick?: () => void
}
export default function QuestionCard ({ title, uuid, completed }: Props) {
  return (
    <Container to={`feedback/${uuid}`} disabled={completed}>
      <Content>
        <span>{title}</span>
      </Content>
      <Button>
        {completed ? <Icon type="check-circle" style={{ color: '#35c135' }}/> : <Icon type="right" />}
      </Button>
    </Container>
  )
}

const Container: any = styled(Link)`
  border-radius: 10px;
  border: 1px solid #f1f1f1;
  padding: 20px;
  background: none;
  cursor: pointer;
  width: 100%;
  margin-bottom: 20px;
  text-align: left;
  outline: none;
  
  display: flex;
  align-items: center;
  
  transform: scale(1);
  transition: all .2s ease-in-out;
  
  :hover {
    transform: scale(1.02);
    background-color: #f9f9f9;
  }
  
  span {
    font-size: 17px;
  }
`

const Content = styled.div`
  flex: 1;
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Button = styled.div`
  padding-left: 20px;
`